import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return <>
        <div  className="cent_align" >
        <img src="/page_not_found.png"  />
        {/* <p style={{textAlign:"center"}}>
            <Link to="/login">Go to Login </Link>
        </p> */}
        </div>
        
        </>;
}
export default NotFoundPage;